import React from 'react';
import '../styles/About.css';

function About() {
  return (
    <div className="about">
      <h1>About</h1>
      <p>This is the about page of our React application.</p>
    </div>
  );
}

export default About; 